import axios from "axios";
import refreshAccessToken from "./refreshToken";
import { getToken } from "./tokenService";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
instance.defaults.headers.common["content-language"] = "en";

// Request Interceptor
instance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token?.token) {
      config.headers["Authorization"] = token.token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response Interceptor
instance.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    const originalRequest = error.config;

    if (
      error?.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/refresh-token")
    ) {
      originalRequest._retry = true;
      try {
        const newToken = await refreshAccessToken();
        originalRequest.headers["Authorization"] = newToken;
        return instance(originalRequest);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }

    if (axios.isCancel(error)) {
      error.__CANCEL__ = true;
    }

    return Promise.reject(error);
  },
);

export default instance;
